const About = () => {
  return (
    <div id="About" className="mt-20 p-5 w-full">
      <div className="md:text-center w-full max-w-[900px] mx-auto">
      <span className='uppercase text-xl tracking-widest text-[#5651e5] '>About</span>

        <h2 className="mb-5" >About Me</h2>
        <p className=" lg:text-center ">Hello there! I&apos;m a Full-Stack Web Developer interested in building websites, E-commerce apps and currently learning how to build mobile apps with react native.</p>
      </div>
    </div>
  )
}

export default About
